






















import {Component, Prop, Vue} from 'vue-property-decorator'
import { Game } from '@/models/Game';
import {Player} from "@/models/Player";

@Component
export default class TheNumberOfPlayersSelector extends Vue {

    @Prop()
    game: Game;

    buttons = ['yellow', 'green', 'blue', 'red'];

    private setNumberOfPlayersEmit(numberOfPlayers: number) {
        this.game.numberOfPlayers = numberOfPlayers;
        const players = [];
        for (let i = 0; i<numberOfPlayers; i++) {
            players.push(new Player());
        }
        this.game.players = players;
        this.$emit('players-selected', this.game)
    }
}
